// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__HcNWP","emails":"CreateEditClinics_emails__2FQzp","emailTagLabel":"CreateEditClinics_emailTagLabel__1_STB"};